module.exports = __webpack_public_path__ + "static/media/routePourLaCanLogo.d31700f9.png";